import { Component, Input, OnInit } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
@Component({
  selector: 'app-input-time',
  templateUrl: './input-time.component.html',
  styleUrls: ['./input-time.component.less']
})
export class InputTimeComponent extends Field {
  resetMinutes: boolean;
  resetSeconds: boolean;
  clearOnOpen: boolean;
  timePickerResetMinutes: boolean;

  constructor(public layoutService: LayoutService) {
    super(layoutService);
    this.resetMinutes = g.uiSettings.resetMinutes;
    this.resetSeconds = g.uiSettings.resetSeconds;
    this.clearOnOpen = g.uiSettings.clearOnOpen;
    this.timePickerResetMinutes = g.uiSettings.timePickerResetMinutes;
  //console.log('UI Settings Loaded:');
  //console.log('resetMinutes:', this.resetMinutes);
  //console.log('resetSeconds:', this.resetSeconds);
  //console.log('clearOnOpen:', this.clearOnOpen);
  //console.log('timePickerResetMinutes:', this.timePickerResetMinutes);
  }

  setMinutesToZero(open: boolean) {
    if (!open || !this.recordProperty?.ValueAsObject) return;
    if (!this.timePickerResetMinutes) { return }
    const newTime = new Date(this.recordProperty.ValueAsObject);

    if (this.resetMinutes) newTime.setMinutes(0);
    if (this.resetSeconds) newTime.setSeconds(0);
    if (this.clearOnOpen) newTime.setHours(0, 0, 0, 0);

    this.recordProperty.ValueAsObject = newTime;
  }

}
